var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomatiserlesconsentements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135.5 125.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_22);}.cls-13,.cls-2,.cls-28,.cls-29,.cls-30,.cls-31,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-45,.cls-47,.cls-49{stroke-miterlimit:10;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_30);stroke:url(#D\xE9grad\xE9_sans_nom_50);}.cls-3{opacity:0.66;}.cls-31,.cls-4,.cls-46,.cls-48{fill:#fff;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_22-2);}.cls-6{opacity:0.32;}.cls-7{fill:#21bbee;}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_22-3);}.cls-10{fill:url(#linear-gradient-2);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_22-4);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_22-5);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_30-2);stroke:url(#D\xE9grad\xE9_sans_nom_50-2);}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_22-6);}.cls-18{fill:url(#linear-gradient-6);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_22-7);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_22-8);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_30-3);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_22-9);}.cls-23{fill:#17243f;}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_22-10);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_22-11);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_22-12);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_22-13);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_30-4);stroke:url(#D\xE9grad\xE9_sans_nom_50-3);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_30-5);stroke:url(#D\xE9grad\xE9_sans_nom_50-4);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_30-6);stroke:url(#D\xE9grad\xE9_sans_nom_50-5);}.cls-31{stroke:#17243e;}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_22-14);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_22-15);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_30-7);stroke:url(#D\xE9grad\xE9_sans_nom_50-6);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_30-8);stroke:url(#D\xE9grad\xE9_sans_nom_50-7);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_30-9);stroke:url(#D\xE9grad\xE9_sans_nom_50-8);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_22-16);stroke:url(#D\xE9grad\xE9_sans_nom_22-17);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_30-10);stroke:url(#D\xE9grad\xE9_sans_nom_50-9);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_30-11);stroke:url(#D\xE9grad\xE9_sans_nom_50-10);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_22-18);stroke:url(#D\xE9grad\xE9_sans_nom_22-19);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_22-20);stroke:url(#D\xE9grad\xE9_sans_nom_22-21);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_30-12);stroke:url(#D\xE9grad\xE9_sans_nom_50-11);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_22-22);stroke:url(#D\xE9grad\xE9_sans_nom_22-23);}.cls-44{opacity:0.64;}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_30-13);stroke:url(#D\xE9grad\xE9_sans_nom_50-12);}.cls-46{opacity:0.72;}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_30-14);stroke:url(#D\xE9grad\xE9_sans_nom_50-13);}.cls-48{opacity:0.56;}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_30-15);stroke:url(#D\xE9grad\xE9_sans_nom_50-14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22",
    x1: 64.66,
    y1: 136.04,
    x2: 68.42,
    y2: 2.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17243e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    x1: 72.32,
    y1: 69.01,
    x2: -78.57,
    y2: 241.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50",
    x1: 8.97,
    y1: 72.93,
    x2: 126.22,
    y2: 72.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#19e9c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1cd5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1fc6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#21beec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-2",
    x1: 76.51,
    y1: 26.77,
    x2: 68.64,
    y2: 107.05,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 892.15,
    y1: 111.82,
    x2: 897.53,
    y2: 105.79,
    gradientTransform: "translate(-773.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-3",
    x1: -6982.72,
    y1: -4608.51,
    x2: -6983.81,
    y2: -4591.66,
    gradientTransform: "matrix(-0.9, -0.44, -0.44, 0.9, -8173.86, 1169.27)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 13329.83,
    y1: 108.51,
    x2: 13376.9,
    y2: 79.04,
    gradientTransform: "translate(-13203.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-4",
    x1: -5728.08,
    y1: -6425.99,
    x2: -5729.18,
    y2: -6409.1,
    gradientTransform: "matrix(-0.79, -0.61, -0.61, 0.79, -8342.57, 1676.36)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-5",
    x1: -10546.4,
    y1: -1045.42,
    x2: -10542.99,
    y2: -1036.86,
    gradientTransform: "matrix(-1.22, -0.42, -0.35, 0.99, -13114.07, -3352.85)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-2",
    x1: 119.21,
    y1: 67.95,
    x2: 99.29,
    y2: 111.53,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-2",
    x1: 98.32,
    y1: 96.19,
    x2: 112.13,
    y2: 96.19,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -8480.21,
    y1: 101.84,
    x2: -8466.62,
    y2: 101.84,
    gradientTransform: "matrix(-1, 0, 0, 1, -8376.71, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -10272.47,
    y1: -614.83,
    x2: -10271.78,
    y2: -619.83,
    gradientTransform: "matrix(-1, -0.07, -0.07, 1, -10180.8, -28.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -10397.09,
    y1: -3480.41,
    x2: -10390.7,
    y2: -3491.79,
    gradientTransform: "matrix(-0.55, -0.84, -0.84, 0.55, -8482.45, -6721.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-6",
    x1: -10395.65,
    y1: -3490.22,
    x2: -10392.52,
    y2: -3482.37,
    gradientTransform: "matrix(-0.55, -0.84, -0.84, 0.55, -8482.45, -6721.23)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -10395.73,
    y1: -3479.68,
    x2: -10389.34,
    y2: -3491.06,
    gradientTransform: "matrix(-0.55, -0.84, -0.84, 0.55, -8482.45, -6721.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-7",
    x1: -8537.27,
    y1: -174.62,
    x2: -8544.38,
    y2: -172.67,
    gradientTransform: "matrix(-1, -0.05, -0.05, 1, -8431.53, -145.59)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-8",
    x1: 3051.84,
    y1: 100.49,
    x2: 3115.67,
    y2: 95.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 3174.4, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-3",
    x1: -8493.48,
    y1: 98.33,
    x2: -8495.82,
    y2: 101.86,
    gradientTransform: "matrix(-1, 0, 0, 1, -8376.71, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-9",
    x1: 46.01,
    y1: 108.13,
    x2: 45.79,
    y2: 111.59,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-10",
    x1: 46,
    y1: 93.61,
    x2: 45.33,
    y2: 107.94,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-11",
    x1: 46.49,
    y1: 83.96,
    x2: 45.49,
    y2: 97.53,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-12",
    x1: -2255.58,
    y1: -588.35,
    x2: -2250.02,
    y2: -588.35,
    gradientTransform: "translate(2081.79 -1023.23) rotate(-42.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-13",
    x1: -2252.3,
    y1: -592.55,
    x2: -2240.44,
    y2: -592.55,
    gradientTransform: "translate(2081.79 -1023.23) rotate(-42.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-4",
    x1: -2237.48,
    y1: -617.67,
    x2: -2248.48,
    y2: -585.55,
    gradientTransform: "translate(2081.79 -1023.23) rotate(-42.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-3",
    x1: 14.97,
    y1: 60.63,
    x2: 39.45,
    y2: 60.63,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-5",
    x1: 15.9,
    y1: 60.63,
    x2: 38.52,
    y2: 60.63,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-4",
    x1: 15.21,
    y1: 60.63,
    x2: 39.21,
    y2: 60.63,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-6",
    x1: -2257.72,
    y1: -564.1,
    x2: -2238.33,
    y2: -564.1,
    gradientTransform: "translate(2081.79 -1023.23) rotate(-42.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-5",
    x1: 35.72,
    y1: 84.57,
    x2: 55.87,
    y2: 84.57,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-14",
    x1: -2227.41,
    y1: -610.21,
    x2: -2225.98,
    y2: -620.19,
    gradientTransform: "translate(2081.79 -1023.23) rotate(-42.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-15",
    x1: -2245.92,
    y1: -623.72,
    x2: -2199.46,
    y2: -623.72,
    gradientTransform: "translate(2081.79 -1023.23) rotate(-42.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-7",
    x1: -2221.54,
    y1: -633.91,
    x2: -2224.45,
    y2: -616.86,
    gradientTransform: "translate(2081.79 -1023.23) rotate(-42.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-6",
    x1: 12.24,
    y1: 23.36,
    x2: 34.24,
    y2: 23.36,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-8",
    x1: 12.94,
    y1: 23.36,
    x2: 33.54,
    y2: 23.36,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-7",
    x1: 12.25,
    y1: 23.36,
    x2: 34.23,
    y2: 23.36,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-9",
    x1: -2253.27,
    y1: -622.39,
    x2: -2237.69,
    y2: -622.39,
    gradientTransform: "translate(2081.79 -1023.23) rotate(-42.64)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-8",
    x1: 0,
    y1: 39.97,
    x2: 16.37,
    y2: 39.97,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-16",
    x1: 2279.76,
    y1: -1058.3,
    x2: 2307.13,
    y2: -1058.3,
    gradientTransform: "matrix(0.85, 0.52, -0.52, 0.85, -2458.36, -274.58)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-17",
    x1: 36.9,
    y1: 12.77,
    x2: 64.08,
    y2: 12.77,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-10",
    x1: 2290.1,
    y1: -1066.83,
    x2: 2270.38,
    y2: -1048.1,
    gradientTransform: "matrix(0.85, 0.52, -0.52, 0.85, -2458.36, -274.58)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-9",
    x1: 34.07,
    y1: 6.71,
    x2: 47.14,
    y2: 6.71,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-11",
    x1: 2289.16,
    y1: -1041.87,
    x2: 2307.7,
    y2: -1058.08,
    gradientTransform: "matrix(0.85, 0.52, -0.52, 0.85, -2458.36, -274.58)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-10",
    x1: 59.22,
    y1: 20.76,
    x2: 66.6,
    y2: 20.76,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-18",
    x1: 2334,
    y1: -1062.96,
    x2: 2317.63,
    y2: -1063.16,
    gradientTransform: "matrix(0.85, 0.52, -0.52, 0.85, -2458.36, -274.58)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-19",
    x1: 68.38,
    y1: 22.02,
    x2: 81.64,
    y2: 22.02,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-20",
    x1: 2334.04,
    y1: -1052.28,
    x2: 2317.6,
    y2: -1052.48,
    gradientTransform: "matrix(0.85, 0.52, -0.52, 0.85, -2458.36, -274.58)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-21",
    x1: 64.43,
    y1: 30.26,
    x2: 77.04,
    y2: 30.26,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-12",
    x1: 2311.23,
    y1: -1057.9,
    x2: 2315.7,
    y2: -1057.9,
    gradientTransform: "matrix(0.85, 0.52, -0.52, 0.85, -2458.36, -274.58)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-11",
    x1: 63.48,
    y1: 23.08,
    x2: 71.01,
    y2: 23.08,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-22",
    x1: 2313.29,
    y1: -1061.43,
    x2: 2305.91,
    y2: -1052.76,
    gradientTransform: "matrix(0.85, 0.52, -0.52, 0.85, -2458.36, -274.58)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-23",
    x1: 60.72,
    y1: 22.26,
    x2: 69.61,
    y2: 22.26,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-13",
    x1: 57.28,
    y1: 65.94,
    x2: 97.63,
    y2: 65.94,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-12",
    x1: 56.78,
    y1: 65.94,
    x2: 98.13,
    y2: 65.94,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-14",
    x1: 105.43,
    y1: 57.19,
    x2: 122.95,
    y2: 57.19,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-13",
    x1: 104.93,
    y1: 57.19,
    x2: 123.45,
    y2: 57.19,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-15",
    x1: 84.43,
    y1: 33.32,
    x2: 110.26,
    y2: 33.32,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_50-14",
    x1: 83.93,
    y1: 33.32,
    x2: 110.76,
    y2: 33.32,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_50"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.21,108.67a2.15,2.15,0,0,1-2.11,2.17H9.61a2.16,2.16,0,0,1-2.12-2.17L6.54,41a3.72,3.72,0,0,1,3.88-3.35l111.89-3a5.27,5.27,0,0,1,3.91,1.6,5.55,5.55,0,0,1,1.56,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.12,106.58a2,2,0,0,1-2,2.06H12.37a2,2,0,0,1-2-2.06l-.9-61.44a5,5,0,0,1,5.17-5l107.23-3a3.71,3.71,0,0,1,2.75,1.12,4,4,0,0,1,1.1,2.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.38,65a.16.16,0,0,1-.16-.16l-.28-19.09a4.13,4.13,0,0,1,1.14-3,5.24,5.24,0,0,1,3.58-1.26l34.24-1h0a.16.16,0,0,1,.16.16.16.16,0,0,1-.16.17l-34.25.95A5,5,0,0,0,12.3,43a3.75,3.75,0,0,0-1,2.78l.27,19.08a.16.16,0,0,1-.16.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.2,103.17c.12-5.08.07-50.05-.21-53.93s5.6-4.61,14.63-5.05,85.19-2.17,87.15-2.33c4.41-.37,4.78,6.4,4.88,21.12.06,8.73.08,22.39.09,32a11,11,0,0,1-10.94,11.16c-24.86-.24-83.78-.78-88-.65C17.4,105.67,15.16,105.18,15.2,103.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.53,
    y: 110.51,
    width: 134.97,
    height: 5.95,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M16,51.15l1.17,48.7a2.78,2.78,0,0,0,2.69,2.85l19.68-.19a2.79,2.79,0,0,0,2.63-2.92L42,50.12a2.79,2.79,0,0,0-2.78-2.92l-20.68,1A2.8,2.8,0,0,0,16,51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.69,50.48l.94,49.33a2.76,2.76,0,0,0,2.62,2.86l67.92-.85a2.76,2.76,0,0,0,2.54-3l-1.09-49.63A2.77,2.77,0,0,0,115,46.35L47.22,47.51A2.76,2.76,0,0,0,44.69,50.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.31,119.51s-8.66-15.59-9.83-17.05a.89.89,0,0,0-.81-.34l-2.42.3-2.83,6.31,4.72-2.83c-.46,3.33,5.61,8.27,7.69,10.07a.51.51,0,0,1,0,.72l-.83.9a9.55,9.55,0,0,0,4.71,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121.52,117.1a1.24,1.24,0,0,0-.71.67.55.55,0,0,0,.2.64,27.2,27.2,0,0,0,5.08,3.13.16.16,0,0,0,.19-.19,5.09,5.09,0,0,0-1-1.88l.07.14a.19.19,0,0,1-.26.25A14.21,14.21,0,0,1,121.52,117.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M121.94,123.34s-1.31-3.23-1.32-3.24a58,58,0,0,0-5-15.51.91.91,0,0,0-.73-.5l-2.42-.21-4,5.59,5.18-1.79c-1.11,3.16,3.86,9.27,5.55,11.47a.5.5,0,0,1-.11.71l-1,.7a9.6,9.6,0,0,0,4.08,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M118.7,120.19a1.23,1.23,0,0,0-.83.5.56.56,0,0,0,.08.67,27.42,27.42,0,0,0,4.36,4.12.15.15,0,0,0,.22-.14,4.89,4.89,0,0,0-.61-2l0,.15a.19.19,0,0,1-.3.19A14.64,14.64,0,0,1,118.7,120.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101.18,102.7s-2.19,3.35-2.37,4.88.6,2.06,2.9,2.26c6.82.58,10.19-1.53,10.19-1.53.47-3.06.8-3.84,4.7-5.5,0,0-4.94.4-5.93,0S101.18,102.7,101.18,102.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M112.49,84.1a2.54,2.54,0,0,0-4,.22c-.34.42-1.8,0-2.26.87a1.25,1.25,0,0,1-1.41.57c-1.52-.33-4-.5-5,1.49a2.08,2.08,0,0,0,.91,3.06,1.33,1.33,0,0,1,.63,1.8c-.35.57-.38,1.35.7,2.37,2.42,2.27,6.69-1,6.69-1l3.09-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M107.11,102.26a49.77,49.77,0,0,0,3.8-4.16,3.57,3.57,0,0,0,.58-3.16,44.63,44.63,0,0,0-1.68-4.37c-.15-.49-3-.47-3-.47A22.4,22.4,0,0,0,99,100.23l2.48.79a30,30,0,0,1,2.93-4.15s-2.52,3.42-2.61,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M112,103.24l-1.92-2.14-2.21.61a12.5,12.5,0,0,1-4.06,0l-1.48-.41L99,100.23l-.53,1.52a.94.94,0,0,0,.33,1.06,6.69,6.69,0,0,0,.84.54c.44.2,10.13.06,10.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M108.77,86.56l-1.92,3.68c.12.8,2.09.82,2.39.35a.49.49,0,0,0,.06-.17L110.45,88c0-.24-.59-1-.8-1.16l-.76-.42C108.59,86.22,109.82,86.21,108.77,86.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M112.66,85.7a4.43,4.43,0,0,1-.73,2.82c-1,1.58-1.9,1.51-2.38.94a3.53,3.53,0,0,1-.79-3.07C109,84.81,112.33,84.11,112.66,85.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M109.91,86.56s1.54-2.08,2.72-.27l0,.63s1.53-.08,1.37-1.53a2.32,2.32,0,0,0-3.16-2c-1.74.5-2.76,1.07-2.95,2.31s.79,1,.79,1,.37-.86.83-.92.29.62.29.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M109.56,86.5s.79-1.06.07-1.28-.7,1-.65,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M105.62,104.09h8.84a.41.41,0,0,0,0-.81h-8.82a.4.4,0,0,0-.4.41A.41.41,0,0,0,105.62,104.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M122.39,95.85H115a1.38,1.38,0,0,0-1.26.83l-3.4,7.41h9.13a.84.84,0,0,0,.79-.56l2.64-6.85A.61.61,0,0,0,122.39,95.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M117.22,99.65c-.16.51,0,1,.26,1.11s.68-.24.84-.74,0-1-.27-1.11S117.37,99.14,117.22,99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M75.37,114.33H15.72a1,1,0,0,0,0,2H75.37a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M66.92,104.24H24.17a2.36,2.36,0,0,0-2.33,2.4v7.69H69.26v-7.69A2.37,2.37,0,0,0,66.92,104.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M63.76,100H27.33a2.37,2.37,0,0,0-2.33,2.4v1.89H66.09v-1.89A2.36,2.36,0,0,0,63.76,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M41.2,87.29h8.69a6.63,6.63,0,0,1,6.63,6.63v6a0,0,0,0,1,0,0H34.57a0,0,0,0,1,0,0v-6A6.63,6.63,0,0,1,41.2,87.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M9.76,51.09A1.41,1.41,0,0,0,9.66,53l30,36.08a1.31,1.31,0,0,0,1.92.11l2.56-2.42L11.09,49.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M13.87,39.5a2.65,2.65,0,0,0-3.79-.12l-2.7,2.55a2.85,2.85,0,0,0-.19,3.9L43,87.87l7.51-7.12a1.54,1.54,0,0,0,.06-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M16.44,48.31l-.28.27A2.25,2.25,0,0,0,16,51.7l18.9,21.12A2.11,2.11,0,0,0,38,73l.28-.27a2.25,2.25,0,0,0,.12-3.12L19.48,48.44A2.11,2.11,0,0,0,16.44,48.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "38.52 72.44 37.72 73.19 15.9 48.82 16.7 48.07 38.52 72.44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 45.8,
    cy: 84.57,
    rx: 9.57,
    ry: 9.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 45.8,
    cy: 84.57,
    rx: 7.31,
    ry: 7.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M9.35,41.85,11.24,44a1.06,1.06,0,0,0,1.55,0L39.14,17.17a1.12,1.12,0,0,0,0-1.54l-1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M39.68,6.23l2,2.23a2.29,2.29,0,0,1-.09,3.13L10.2,42.79l-5.56-6.2a1.24,1.24,0,0,1,.09-1.74L36.63,6.07A2.14,2.14,0,0,1,39.68,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M30.59,13.77,13.35,30.11a2,2,0,0,0-.11,2.73,1.84,1.84,0,0,0,2.65.11L33.14,16.62a2,2,0,0,0,.1-2.73A1.84,1.84,0,0,0,30.59,13.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "12.95 32.51 13.53 33.16 33.54 14.21 32.95 13.56 12.95 32.51"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 8.19,
    cy: 39.97,
    rx: 7.69,
    ry: 7.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 8.19,
    cy: 39.97,
    rx: 5.87,
    ry: 6.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M63.26,19.48l-1.2,2a1.53,1.53,0,0,1-2,.83L37.58,9.25l3.35-5.66A.81.81,0,0,1,42,3.16l21,14.14A1.63,1.63,0,0,1,63.26,19.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 40.61,
    cy: 6.71,
    rx: 6.03,
    ry: 6.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 40.61,
    cy: 6.71,
    rx: 4.61,
    ry: 4.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M66.05,18l-2.19-1.36a.11.11,0,0,0-.15,0l-4,6.79a.11.11,0,0,0,0,.15L62,24.93a.1.1,0,0,0,.14,0l4-6.79A.11.11,0,0,0,66.05,18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "68.97 20.72 74.01 16.97 80.99 25.71 79.93 27 73.62 20.03 69.72 22.97 68.97 20.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "65.76 26.25 64.98 32.59 75.78 34.71 76.37 33.13 67.4 30.77 68.03 25.84 65.76 26.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M64.13,26.08a3.8,3.8,0,0,0,3.83.66,4.06,4.06,0,0,0,2.31-5.16,4,4,0,0,0-2.07-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M61.91,24.67l-.64,1.09a.44.44,0,0,0,.16.58l2,1.22a.41.41,0,0,0,.58-.13l5.09-8.67a.44.44,0,0,0-.16-.58l-2-1.22a.4.4,0,0,0-.57.13l-.59,1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.39,80.86a.42.42,0,0,1-.35-.19c-.11-.2-.23-.39-.34-.58a.44.44,0,0,1,.14-.58.4.4,0,0,1,.56.15l.33.56a.43.43,0,0,1-.13.58A.39.39,0,0,1,55.39,80.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.05,78.4a.4.4,0,0,1-.36-.24c-.19-.4-.38-.81-.55-1.22a.42.42,0,0,1,.22-.55.4.4,0,0,1,.53.22c.16.39.34.79.53,1.18a.42.42,0,0,1-.19.56A.41.41,0,0,1,54.05,78.4Zm-1.28-3.22a.42.42,0,0,1-.39-.28q-.21-.65-.39-1.29a.43.43,0,0,1,.28-.52.42.42,0,0,1,.51.29c.11.42.24.84.37,1.25a.42.42,0,0,1-.25.53Zm-.88-3.36a.4.4,0,0,1-.39-.34c-.09-.43-.16-.88-.23-1.32a.43.43,0,0,1,.34-.48.41.41,0,0,1,.46.35c.07.43.14.87.22,1.29a.41.41,0,0,1-.32.49Zm-.44-3.45A.41.41,0,0,1,51,68c0-.44,0-.9-.06-1.34a.43.43,0,0,1,.4-.43h0a.42.42,0,0,1,.41.41c0,.44,0,.87.05,1.31a.4.4,0,0,1-.38.44Zm0-3.48h0a.41.41,0,0,1-.38-.44c0-.45.06-.9.11-1.34a.41.41,0,0,1,.45-.37.42.42,0,0,1,.36.46c-.05.43-.08.87-.11,1.3A.41.41,0,0,1,51.43,64.89Zm.43-3.45h-.07a.41.41,0,0,1-.33-.49c.09-.44.18-.88.29-1.31a.4.4,0,0,1,.49-.31.43.43,0,0,1,.3.51c-.11.42-.2.85-.28,1.27A.41.41,0,0,1,51.86,61.44Zm.86-3.36-.12,0a.42.42,0,0,1-.26-.53c.14-.43.29-.85.44-1.27a.41.41,0,0,1,.53-.24.42.42,0,0,1,.23.54c-.15.41-.3.82-.43,1.23A.41.41,0,0,1,52.72,58.08ZM54,54.86a.41.41,0,0,1-.18,0,.41.41,0,0,1-.18-.55q.28-.61.6-1.2a.4.4,0,0,1,.55-.17.43.43,0,0,1,.16.57c-.2.38-.4.77-.58,1.16A.41.41,0,0,1,54,54.86Zm1.67-3a.36.36,0,0,1-.22-.07.43.43,0,0,1-.12-.58c.24-.37.49-.74.75-1.1a.38.38,0,0,1,.56-.09.42.42,0,0,1,.09.58c-.25.35-.49.71-.72,1.07A.42.42,0,0,1,55.67,51.83Zm2-2.78a.37.37,0,0,1-.26-.1.43.43,0,0,1,0-.59c.29-.34.58-.67.88-1a.41.41,0,0,1,.58,0,.43.43,0,0,1,0,.59c-.29.31-.57.64-.85,1A.41.41,0,0,1,57.7,49.05Zm2.37-2.48a.41.41,0,0,1-.31-.14.43.43,0,0,1,0-.59l1-.88a.41.41,0,0,1,.57.06.43.43,0,0,1-.06.59c-.33.28-.65.56-1,.85A.43.43,0,0,1,60.07,46.57Zm2.65-2.15a.4.4,0,0,1-.33-.18.44.44,0,0,1,.1-.59c.36-.25.73-.49,1.1-.73a.39.39,0,0,1,.55.14.42.42,0,0,1-.13.57c-.36.23-.71.47-1.06.71A.4.4,0,0,1,62.72,44.42Zm2.9-1.78a.4.4,0,0,1-.36-.23.43.43,0,0,1,.18-.56c.39-.2.78-.4,1.18-.58a.4.4,0,0,1,.54.21A.42.42,0,0,1,67,42c-.38.18-.77.37-1.14.57A.41.41,0,0,1,65.62,42.64Zm3.11-1.37a.4.4,0,0,1-.38-.28.41.41,0,0,1,.24-.53c.41-.15.83-.3,1.25-.42a.4.4,0,0,1,.5.28.42.42,0,0,1-.27.52c-.4.12-.81.26-1.21.4A.31.31,0,0,1,68.73,41.27Zm14.6-.89h-.09L82,40.11a.42.42,0,0,1,.15-.82l1.28.27a.41.41,0,0,1,.3.5A.4.4,0,0,1,83.33,40.38ZM72,40.32a.42.42,0,0,1-.09-.83l.16,0c.37-.08.75-.16,1.13-.22a.41.41,0,0,1,.47.34.43.43,0,0,1-.34.48l-1.09.21-.15,0Zm8-.49h0l-1.26-.09a.41.41,0,0,1-.39-.43.41.41,0,0,1,.42-.4c.44,0,.88.05,1.31.09a.42.42,0,0,1,.36.46A.41.41,0,0,1,80,39.83Zm-4.67,0a.4.4,0,0,1-.4-.38.41.41,0,0,1,.37-.45c.43,0,.87-.07,1.31-.08a.42.42,0,0,1,0,.83c-.42,0-.84,0-1.26.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86,41.16a.27.27,0,0,1-.13,0l-.61-.21a.42.42,0,0,1-.27-.52.41.41,0,0,1,.51-.27l.63.21a.42.42,0,0,1,.25.53A.39.39,0,0,1,86,41.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101,54.84a.4.4,0,0,1-.36-.24c-.09-.19-.19-.39-.29-.58a.44.44,0,0,1,.18-.57.42.42,0,0,1,.55.18c.1.2.19.41.29.61a.42.42,0,0,1-.19.56A.39.39,0,0,1,101,54.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.47,93.42H77a.42.42,0,0,1,0-.84c.42,0,.84,0,1.25,0a.42.42,0,0,1,.42.41.41.41,0,0,1-.39.43ZM75,93.3h0c-.43,0-.86-.1-1.28-.16a.42.42,0,0,1-.34-.48.41.41,0,0,1,.46-.35l1.24.16a.42.42,0,0,1,0,.83Zm5.38,0a.41.41,0,0,1-.4-.37.4.4,0,0,1,.35-.46c.42-.05.83-.11,1.24-.18a.42.42,0,0,1,.47.35.43.43,0,0,1-.34.48c-.42.07-.85.13-1.28.18Zm-8.67-.51h-.09l-1.25-.33a.42.42,0,0,1-.28-.51.41.41,0,0,1,.5-.29l1.21.32a.42.42,0,0,1,.31.5A.41.41,0,0,1,71.68,92.75Zm11.95-.08a.42.42,0,0,1-.4-.32.43.43,0,0,1,.3-.51c.41-.1.81-.21,1.21-.33a.42.42,0,0,1,.23.8c-.41.13-.83.24-1.25.35Zm3.18-1a.41.41,0,0,1-.38-.27.42.42,0,0,1,.23-.54c.39-.15.78-.32,1.16-.49a.4.4,0,0,1,.53.22.42.42,0,0,1-.21.55l-1.19.5Zm3-1.42a.42.42,0,0,1-.36-.22.43.43,0,0,1,.17-.57c.37-.2.73-.41,1.09-.63a.39.39,0,0,1,.55.14.41.41,0,0,1-.14.57c-.36.23-.74.45-1.12.66A.41.41,0,0,1,89.83,90.24Zm2.83-1.81a.4.4,0,0,1-.33-.17.44.44,0,0,1,.09-.59c.34-.24.67-.5,1-.77A.4.4,0,0,1,94,87a.43.43,0,0,1-.07.59c-.33.27-.68.54-1,.79A.34.34,0,0,1,92.66,88.43Zm2.57-2.16a.43.43,0,0,1-.29-.13.41.41,0,0,1,0-.59c.3-.29.6-.6.89-.9a.4.4,0,0,1,.58,0,.42.42,0,0,1,0,.59c-.3.32-.61.63-.92.93A.43.43,0,0,1,95.23,86.27Zm2.29-2.48a.39.39,0,0,1-.26-.1.43.43,0,0,1-.05-.59c.27-.33.53-.66.78-1a.4.4,0,0,1,.57-.09.44.44,0,0,1,.08.59c-.26.35-.53.7-.8,1A.42.42,0,0,1,97.52,83.79Zm2-2.76a.36.36,0,0,1-.22-.07.43.43,0,0,1-.12-.58c.22-.36.44-.73.64-1.1a.41.41,0,0,1,.56-.15.43.43,0,0,1,.15.57c-.21.38-.44.76-.67,1.13A.4.4,0,0,1,99.49,81Zm1.61-3a.33.33,0,0,1-.17,0,.43.43,0,0,1-.2-.56c.18-.38.35-.78.51-1.17a.41.41,0,0,1,.53-.23.42.42,0,0,1,.22.55c-.16.41-.34.81-.52,1.21A.41.41,0,0,1,101.1,78Zm1.23-3.18-.13,0a.43.43,0,0,1-.26-.53c.13-.4.25-.82.36-1.23a.41.41,0,0,1,.5-.29.41.41,0,0,1,.28.51c-.11.43-.23.85-.36,1.27A.41.41,0,0,1,102.33,74.85Zm.82-3.32h-.07a.43.43,0,0,1-.33-.49c.08-.42.15-.85.21-1.27a.4.4,0,0,1,.45-.36.41.41,0,0,1,.35.47c-.06.44-.13.88-.21,1.31A.4.4,0,0,1,103.15,71.53Zm.41-3.4h0a.42.42,0,0,1-.39-.44c0-.42,0-.86,0-1.28a.41.41,0,0,1,.4-.42h0a.42.42,0,0,1,.4.42c0,.44,0,.89,0,1.33A.42.42,0,0,1,103.56,68.13Zm0-3.42a.42.42,0,0,1-.41-.39c0-.42-.07-.85-.11-1.28a.41.41,0,0,1,.35-.46.4.4,0,0,1,.45.36q.08.66.12,1.32a.41.41,0,0,1-.37.45Zm-.45-3.39a.4.4,0,0,1-.39-.34l-.06-.26c-.06-.33-.14-.66-.22-1a.43.43,0,0,1,.3-.51.4.4,0,0,1,.49.31c.08.33.16.68.23,1a2.56,2.56,0,0,1,0,.27.42.42,0,0,1-.32.49ZM102.24,58a.41.41,0,0,1-.39-.29c-.13-.4-.27-.81-.42-1.2a.43.43,0,0,1,.23-.55.41.41,0,0,1,.53.24c.15.41.3.83.44,1.25a.43.43,0,0,1-.26.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.48,91.77l-.14,0-.61-.25A.42.42,0,0,1,67.5,91a.4.4,0,0,1,.53-.23l.59.23a.42.42,0,0,1,.24.54A.4.4,0,0,1,68.48,91.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M67.81,84.21a.32.32,0,0,0,.37,0l3.08-2.3a16.18,16.18,0,0,0,5.26,1.19l1.85,3.43a.3.3,0,0,0,.33.16l4.5-.82a.33.33,0,0,0,.26-.26l.59-3.88a16.5,16.5,0,0,0,4.54-3l3.67,1.08a.33.33,0,0,0,.34-.13l2.62-3.85a.33.33,0,0,0,0-.38L93,72.31a17.54,17.54,0,0,0,1.16-5.41L97.47,65a.33.33,0,0,0,.16-.34L96.83,60a.3.3,0,0,0-.26-.26l-3.76-.62a17.42,17.42,0,0,0-2.89-4.67l1-3.77a.32.32,0,0,0-.12-.35l-3.75-2.7a.29.29,0,0,0-.36,0L83.65,50a16.46,16.46,0,0,0-5.26-1.2l-1.85-3.43a.32.32,0,0,0-.33-.16l-4.5.82a.34.34,0,0,0-.26.27l-.59,3.87a16.53,16.53,0,0,0-4.54,3L62.65,52a.3.3,0,0,0-.34.13L59.69,56a.33.33,0,0,0,0,.38l2.24,3.17A17.48,17.48,0,0,0,60.77,65l-3.33,1.91a.32.32,0,0,0-.16.34l.8,4.63a.31.31,0,0,0,.26.26l3.76.61A17.12,17.12,0,0,0,65,77.39l-1,3.77a.33.33,0,0,0,.12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M77.46,70.45a4.4,4.4,0,0,1-4-2.66,4.65,4.65,0,0,1-.1-3.46,4.49,4.49,0,0,1,2.31-2.51,4.35,4.35,0,0,1,5.8,2.27,4.56,4.56,0,0,1-2.21,6h0A4.24,4.24,0,0,1,77.46,70.45Zm0-8.36a3.65,3.65,0,0,0-1.53.34,3.79,3.79,0,0,0-2,2.14,3.93,3.93,0,0,0,.09,2.94A3.69,3.69,0,0,0,79,69.44l.13.31L79,69.44a3.89,3.89,0,0,0,1.87-5.08A3.73,3.73,0,0,0,77.45,62.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M77.49,77.37h-.42a.17.17,0,0,1-.15-.17h0a.17.17,0,0,1,.17-.16,10.61,10.61,0,0,0,2.31-.16l.74-.16h0a10.75,10.75,0,0,0,6.27-4.43,11.31,11.31,0,0,0,2-6.39,10.85,10.85,0,0,0-.17-2,11.1,11.1,0,0,0-4.47-7.22,10.55,10.55,0,0,0-8.13-1.85,11.1,11.1,0,0,0-9,11,10.86,10.86,0,0,0,.17,2,11.33,11.33,0,0,0,2.48,5.38.15.15,0,0,1,0,.11.15.15,0,0,1,0,.12.16.16,0,0,1-.23,0,11.92,11.92,0,0,1-2.74-7.55,11.45,11.45,0,0,1,9.26-11.34,10.86,10.86,0,0,1,8.36,1.9,11.47,11.47,0,0,1,4.61,7.44,11.65,11.65,0,0,1-1.85,8.61,11.13,11.13,0,0,1-7.23,4.74h0A10.81,10.81,0,0,1,77.49,77.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.33,60.73a.17.17,0,0,1-.16-.12c0-.14-.07-.28-.11-.41a.18.18,0,0,1,.12-.21.17.17,0,0,1,.2.13c0,.13.07.26.1.39a.16.16,0,0,1-.11.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.05,59.5a.16.16,0,0,1-.16-.14c0-.28-.09-.56-.12-.85a.17.17,0,0,1,.15-.18.16.16,0,0,1,.17.15c0,.27.07.55.12.82a.19.19,0,0,1-.13.2Zm-.17-1.68a.16.16,0,0,1-.16-.16c0-.12,0-.24,0-.37s0-.32,0-.48a.15.15,0,0,1,.17-.16.15.15,0,0,1,.15.17c0,.16,0,.32,0,.47s0,.24,0,.36a.17.17,0,0,1-.16.17Zm.06-1.68h0a.17.17,0,0,1-.15-.19c0-.28.08-.56.13-.84a.15.15,0,0,1,.18-.13.16.16,0,0,1,.13.19c0,.27-.08.55-.11.82A.16.16,0,0,1,102.94,56.14Zm.3-1.66h0a.17.17,0,0,1-.11-.21q.1-.41.24-.81a.16.16,0,0,1,.2-.11.16.16,0,0,1,.1.21c-.08.27-.16.53-.23.8A.16.16,0,0,1,103.24,54.48Zm.53-1.59h-.06a.18.18,0,0,1-.09-.22q.16-.39.36-.78a.16.16,0,0,1,.22-.07.17.17,0,0,1,.07.23c-.13.24-.24.5-.35.75A.15.15,0,0,1,103.77,52.89Zm.75-1.5-.08,0a.18.18,0,0,1-.06-.23c.15-.25.3-.49.46-.72a.17.17,0,0,1,.23,0,.19.19,0,0,1,0,.24c-.16.22-.31.46-.45.69A.16.16,0,0,1,104.52,51.39Zm1-1.37a.15.15,0,0,1-.11,0,.16.16,0,0,1,0-.23c.18-.22.36-.44.55-.64a.16.16,0,0,1,.23,0,.17.17,0,0,1,0,.24c-.19.2-.37.41-.54.62A.16.16,0,0,1,105.48,50Zm1.13-1.21a.16.16,0,0,1-.12-.06.18.18,0,0,1,0-.24l.64-.55a.17.17,0,0,1,.23,0,.18.18,0,0,1,0,.24l-.62.53A.16.16,0,0,1,106.61,48.81Zm1.29-1a.17.17,0,0,1-.13-.07.19.19,0,0,1,0-.24l.71-.45a.16.16,0,0,1,.22.07.17.17,0,0,1-.06.23c-.23.13-.46.28-.69.43A.14.14,0,0,1,107.9,47.77Zm11.69-.55-.08,0c-.24-.13-.48-.26-.72-.37a.16.16,0,0,1-.08-.22.15.15,0,0,1,.21-.08,7.39,7.39,0,0,1,.74.38.16.16,0,0,1,.07.22A.16.16,0,0,1,119.59,47.22Zm-10.26-.28a.18.18,0,0,1-.15-.1.16.16,0,0,1,.08-.22c.24-.12.5-.24.76-.34a.17.17,0,0,1,.21.09.17.17,0,0,1-.09.22c-.25.1-.5.21-.74.33Zm8.76-.41h0a7,7,0,0,0-.77-.26.16.16,0,0,1-.11-.21.15.15,0,0,1,.2-.11,7.3,7.3,0,0,1,.79.26.17.17,0,0,1,.1.22A.19.19,0,0,1,118.09,46.53Zm-7.24-.2a.17.17,0,0,1,0-.33c.27-.09.54-.16.8-.22a.16.16,0,0,1,.2.12.17.17,0,0,1-.12.2c-.26.06-.53.14-.78.22Zm5.67-.27h0a7.45,7.45,0,0,0-.8-.14.18.18,0,0,1-.14-.19.17.17,0,0,1,.18-.15c.28,0,.55.09.82.15a.17.17,0,0,1,.13.2A.16.16,0,0,1,116.52,46.06ZM112.45,46a.17.17,0,0,1,0-.34c.27,0,.55-.07.83-.09a.16.16,0,0,1,.17.15.17.17,0,0,1-.15.18,7,7,0,0,0-.8.1Zm2.45-.12h0l-.72,0h-.09a.16.16,0,0,1-.16-.16.16.16,0,0,1,.16-.17h.09c.25,0,.49,0,.74,0a.17.17,0,0,1,.15.18A.16.16,0,0,1,114.9,45.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.64,47.89a.17.17,0,0,1-.1,0l-.33-.23a.17.17,0,0,1,0-.23.16.16,0,0,1,.23,0l.34.23a.19.19,0,0,1,0,.24A.17.17,0,0,1,120.64,47.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.35,55.54a.16.16,0,0,1-.16-.14c0-.14,0-.27-.08-.41a.16.16,0,0,1,.13-.19.16.16,0,0,1,.19.13c0,.13,0,.27.08.41a.19.19,0,0,1-.14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.47,69.08a.16.16,0,0,1-.16-.16.17.17,0,0,1,.16-.17c.26,0,.53,0,.79,0a.17.17,0,0,1,.18.15.17.17,0,0,1-.15.18,7.52,7.52,0,0,1-.82,0Zm-.81,0h-.27l-.55,0a.18.18,0,0,1-.14-.19.17.17,0,0,1,.18-.15l.54,0,.25,0a.17.17,0,0,1,.16.17A.17.17,0,0,1,113.66,69.07Zm2.41-.14a.18.18,0,0,1-.16-.14.19.19,0,0,1,.14-.2c.26,0,.52-.1.77-.16a.16.16,0,1,1,.08.32,7.1,7.1,0,0,1-.8.17Zm-4-.05h0c-.27,0-.53-.12-.8-.19a.17.17,0,0,1-.11-.2.16.16,0,0,1,.2-.12c.25.07.51.13.77.18a.16.16,0,0,1,.13.19A.16.16,0,0,1,112.06,68.88Zm5.58-.35a.16.16,0,0,1,0-.32c.25-.08.5-.18.75-.28a.17.17,0,0,1,.21.09.17.17,0,0,1-.09.22c-.26.11-.51.2-.77.29Zm-7.14-.07h0c-.26-.09-.51-.2-.76-.3a.17.17,0,0,1-.09-.22.15.15,0,0,1,.21-.09l.75.29a.17.17,0,0,1,.1.21A.18.18,0,0,1,110.5,68.46Zm8.63-.54a.15.15,0,0,1-.14-.1.16.16,0,0,1,.07-.22c.24-.12.47-.25.7-.38a.15.15,0,0,1,.22.06.16.16,0,0,1,0,.22c-.24.14-.48.28-.73.4ZM109,67.81l-.07,0-.72-.41a.17.17,0,0,1,0-.23.15.15,0,0,1,.22-.06c.23.14.46.28.7.4a.17.17,0,0,1,.07.23A.19.19,0,0,1,109,67.81Zm11.51-.72a.16.16,0,0,1-.14-.08.17.17,0,0,1,0-.23c.21-.15.43-.31.64-.48a.15.15,0,0,1,.23,0,.17.17,0,0,1,0,.23l-.66.5A.16.16,0,0,1,120.53,67.09Zm1.26-1a.18.18,0,0,1-.12,0,.18.18,0,0,1,0-.24,7.66,7.66,0,0,0,.57-.57.16.16,0,0,1,.23,0,.17.17,0,0,1,0,.24l-.59.59A.15.15,0,0,1,121.79,66.06Zm1.12-1.2a.15.15,0,0,1-.11,0,.16.16,0,0,1,0-.23c.17-.21.33-.43.49-.65a.16.16,0,0,1,.22,0,.16.16,0,0,1,0,.23c-.16.23-.33.46-.5.67A.16.16,0,0,1,122.91,64.86Zm.93-1.35-.08,0a.18.18,0,0,1-.06-.23c.14-.23.27-.47.39-.71a.16.16,0,0,1,.22-.08.18.18,0,0,1,.07.23c-.12.25-.26.49-.4.73A.16.16,0,0,1,123.84,63.51Zm.74-1.47h-.06a.18.18,0,0,1-.09-.22c.11-.25.2-.51.29-.77a.17.17,0,0,1,.21-.1.17.17,0,0,1,.1.21c-.09.27-.19.53-.3.79A.15.15,0,0,1,124.58,62Zm.53-1.57h0a.18.18,0,0,1-.12-.21c.07-.26.13-.53.18-.79a.17.17,0,0,1,.19-.14.17.17,0,0,1,.13.2c0,.27-.11.55-.18.82A.17.17,0,0,1,125.11,60.47Zm.31-1.63h0a.17.17,0,0,1-.15-.18,5.9,5.9,0,0,0,.06-.59c0-.07,0-.15,0-.23a.17.17,0,0,1,.17-.16.18.18,0,0,1,.16.18c0,.08,0,.16,0,.24s0,.4,0,.6A.16.16,0,0,1,125.42,58.84Zm.08-1.65a.17.17,0,0,1-.17-.16c0-.28,0-.55,0-.82a.16.16,0,1,1,.32,0c0,.28,0,.56,0,.84a.17.17,0,0,1-.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.64,66.94a.17.17,0,0,1-.1,0l-.33-.25a.18.18,0,0,1,0-.24.17.17,0,0,1,.23,0,3.92,3.92,0,0,0,.32.25.17.17,0,0,1,0,.23A.15.15,0,0,1,107.64,66.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M108.08,63.64a.12.12,0,0,0,.15,0l1.55-.58a7.07,7.07,0,0,0,2,1.13l.38,1.66a.12.12,0,0,0,.12.1l2,.21a.14.14,0,0,0,.14-.08l.69-1.54a7.07,7.07,0,0,0,2.23-.69l1.41.89a.14.14,0,0,0,.16,0l1.53-1.29a.13.13,0,0,0,0-.15l-.57-1.6A7.59,7.59,0,0,0,121,59.62l1.61-.39a.14.14,0,0,0,.1-.12l.2-2a.12.12,0,0,0-.08-.14l-1.5-.72a7.39,7.39,0,0,0-.67-2.29l.87-1.45a.14.14,0,0,0,0-.16l-1.25-1.58a.13.13,0,0,0-.15,0l-1.55.58a7.25,7.25,0,0,0-2.06-1.13l-.38-1.66a.12.12,0,0,0-.11-.1l-2-.21a.13.13,0,0,0-.13.08l-.7,1.54a7.15,7.15,0,0,0-2.23.69l-1.4-.89a.13.13,0,0,0-.16,0l-1.54,1.29a.14.14,0,0,0,0,.15l.57,1.6a7.31,7.31,0,0,0-1.1,2.11l-1.61.39a.15.15,0,0,0-.11.12l-.2,2a.15.15,0,0,0,.08.14l1.5.72a7.39,7.39,0,0,0,.67,2.29l-.87,1.45a.15.15,0,0,0,0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M114.19,59.17a1.89,1.89,0,0,1-1.14-.39,2,2,0,0,1,.86-3.55,1.93,1.93,0,0,1,2.18,1.67,2,2,0,0,1-.35,1.47,2,2,0,0,1-1.27.78Zm0-3.62H114a1.66,1.66,0,0,0-.72,2.95,1.58,1.58,0,0,0,1.19.31h0a1.59,1.59,0,0,0,1-.65,1.65,1.65,0,0,0-1.28-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M114.23,62.25a4.36,4.36,0,0,1-.51,0h0a5,5,0,0,1-.93-.19h0l-.08,0a.18.18,0,0,1-.11-.16.09.09,0,0,1,0-.05.16.16,0,0,1,.2-.11,5.23,5.23,0,0,0,1,.21h.18a4.36,4.36,0,0,0,2.33-.48,4.92,4.92,0,0,0,.83-.54l0,0a4.73,4.73,0,0,0,1.68-3.2,4,4,0,0,0,0-.49,4.82,4.82,0,0,0-1-3,4.56,4.56,0,0,0-3.11-1.72,4.65,4.65,0,0,0-5.06,4.25,3.87,3.87,0,0,0,0,.48,4.83,4.83,0,0,0,.44,2,.15.15,0,0,1,0,.07.16.16,0,0,1-.09.15.17.17,0,0,1-.22-.08,5.34,5.34,0,0,1-.46-2.16c0-.17,0-.34,0-.51a5,5,0,0,1,5.42-4.55,4.86,4.86,0,0,1,3.33,1.84,5.14,5.14,0,0,1,1.12,3.21,4.53,4.53,0,0,1,0,.52,5.1,5.1,0,0,1-1.79,3.43A4.81,4.81,0,0,1,114.23,62.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.32,38.71a.41.41,0,0,1-.39-.3c-.06-.22-.12-.44-.17-.66a.42.42,0,0,1,.29-.51.4.4,0,0,1,.49.31c.06.2.11.42.17.62a.42.42,0,0,1-.28.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.77,35.92a.41.41,0,0,1-.41-.37c0-.45-.09-.91-.1-1.37a.41.41,0,0,1,.39-.43.41.41,0,0,1,.42.4c0,.43.05.87.1,1.31a.41.41,0,0,1-.36.46Zm-.06-3.51h0a.41.41,0,0,1-.37-.45c0-.45.09-.91.16-1.36a.42.42,0,0,1,.47-.35.42.42,0,0,1,.33.48c-.06.43-.12.87-.15,1.3A.42.42,0,0,1,80.71,32.41ZM81.35,29a.25.25,0,0,1-.12,0,.41.41,0,0,1-.27-.52c.13-.43.27-.87.43-1.3a.41.41,0,0,1,.53-.24.42.42,0,0,1,.23.54c-.15.41-.29.83-.41,1.24A.42.42,0,0,1,81.35,29Zm1.31-3.25a.32.32,0,0,1-.19-.05.41.41,0,0,1-.17-.56c.21-.41.44-.8.68-1.19a.42.42,0,0,1,.57-.12.44.44,0,0,1,.12.58c-.23.36-.45.74-.65,1.12A.42.42,0,0,1,82.66,25.7Zm1.93-2.9a.37.37,0,0,1-.26-.1.42.42,0,0,1,0-.59c.29-.35.59-.69.9-1a.39.39,0,0,1,.58,0,.43.43,0,0,1,0,.59c-.3.31-.59.63-.86,1A.4.4,0,0,1,84.59,22.8Zm2.46-2.44a.39.39,0,0,1-.32-.16.43.43,0,0,1,.07-.59c.35-.28.71-.55,1.08-.8a.4.4,0,0,1,.57.12.43.43,0,0,1-.12.58c-.35.24-.7.49-1,.76A.38.38,0,0,1,87.05,20.36Zm2.89-1.87a.4.4,0,0,1-.36-.24.43.43,0,0,1,.18-.56c.4-.2.81-.39,1.22-.56a.41.41,0,0,1,.53.24.42.42,0,0,1-.23.54c-.39.16-.78.34-1.16.53A.41.41,0,0,1,89.94,18.49Zm14.5-.14a.59.59,0,0,1-.17,0c-.38-.19-.78-.36-1.17-.51a.43.43,0,0,1-.24-.54.41.41,0,0,1,.53-.25c.41.16.83.35,1.23.54a.42.42,0,0,1,.19.56A.4.4,0,0,1,104.44,18.35Zm-11.3-1.09a.42.42,0,0,1-.1-.82c.43-.12.87-.22,1.31-.3a.41.41,0,0,1,.47.34.42.42,0,0,1-.33.49c-.42.07-.83.17-1.24.28Zm8.08-.08h-.1c-.41-.1-.83-.18-1.25-.25a.41.41,0,0,1-.33-.48.41.41,0,0,1,.46-.35c.44.07.88.16,1.31.27a.42.42,0,0,1,.3.5A.4.4,0,0,1,101.22,17.18Zm-4.7-.45a.42.42,0,0,1,0-.83c.27,0,.55,0,.82,0h.52a.42.42,0,0,1,0,.83h-.51l-.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.85,19.78a.4.4,0,0,1-.23-.08l-.53-.36a.43.43,0,0,1-.13-.58.42.42,0,0,1,.57-.13l.55.38a.44.44,0,0,1,.1.59A.41.41,0,0,1,106.85,19.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.8,31.11a.42.42,0,0,1-.4-.35c0-.21-.07-.43-.11-.64a.4.4,0,1,1,.79-.17c0,.23.09.45.12.68a.4.4,0,0,1-.33.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.21,51h0c-.35,0-.7,0-1,0l-.26,0a.42.42,0,0,1-.37-.46.41.41,0,0,1,.44-.38l.25,0c.33,0,.67,0,1,0a.42.42,0,0,1,.4.43A.41.41,0,0,1,97.21,51Zm2.08-.12a.41.41,0,0,1-.41-.37.43.43,0,0,1,.36-.46c.41-.05.83-.12,1.24-.2a.42.42,0,0,1,.15.82c-.43.09-.86.16-1.3.21Zm-5.43-.25h-.08c-.43-.1-.86-.21-1.28-.33a.42.42,0,0,1-.27-.52.41.41,0,0,1,.5-.29c.4.12.81.23,1.22.32a.42.42,0,0,1,.31.49A.41.41,0,0,1,93.86,50.67Zm8.71-.49a.39.39,0,0,1-.38-.29.41.41,0,0,1,.25-.53,11.78,11.78,0,0,0,1.17-.45.41.41,0,0,1,.54.22.43.43,0,0,1-.22.55c-.4.17-.82.33-1.23.48Zm-11.91-.57a.51.51,0,0,1-.17,0c-.4-.18-.79-.38-1.18-.59a.43.43,0,0,1-.17-.57.4.4,0,0,1,.55-.17c.37.2.75.39,1.13.56a.42.42,0,0,1,.21.55A.41.41,0,0,1,90.66,49.61Zm15-.85a.38.38,0,0,1-.35-.21.41.41,0,0,1,.15-.57c.36-.21.71-.44,1.06-.68a.4.4,0,0,1,.56.11A.42.42,0,0,1,107,48q-.54.38-1.11.72A.35.35,0,0,1,105.64,48.76Zm2.73-2a.41.41,0,0,1-.3-.14.42.42,0,0,1,0-.59c.31-.29.62-.59.91-.89a.39.39,0,0,1,.57,0,.42.42,0,0,1,0,.59c-.3.32-.62.64-1,.93A.4.4,0,0,1,108.37,46.75Zm2.29-2.54a.4.4,0,0,1-.25-.09.42.42,0,0,1-.08-.58c.25-.34.49-.7.72-1.06a.4.4,0,0,1,.56-.12.42.42,0,0,1,.12.57c-.23.38-.49.75-.75,1.11A.4.4,0,0,1,110.66,44.21Zm1.74-3a.35.35,0,0,1-.17,0,.42.42,0,0,1-.19-.56c.18-.38.34-.78.49-1.18a.41.41,0,0,1,.53-.24.43.43,0,0,1,.23.54c-.16.42-.33.84-.52,1.24A.41.41,0,0,1,112.4,41.25ZM113.53,38h-.09a.42.42,0,0,1-.3-.51c.1-.41.18-.84.25-1.26a.4.4,0,0,1,.47-.34.41.41,0,0,1,.33.48c-.07.44-.16.89-.26,1.32A.42.42,0,0,1,113.53,38Zm.47-3.43h0a.4.4,0,0,1-.39-.43c0-.23,0-.46,0-.69s0-.4,0-.6a.41.41,0,0,1,.39-.43.41.41,0,0,1,.42.4c0,.21,0,.42,0,.63s0,.48,0,.72A.41.41,0,0,1,114,34.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.72,47.9a.42.42,0,0,1-.24-.07L87,47.42a.42.42,0,0,1-.08-.58.39.39,0,0,1,.57-.08l.51.39a.41.41,0,0,1-.23.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M88.32,42.84a.22.22,0,0,0,.23.06L90.84,42a10.4,10.4,0,0,0,3,1.68l.56,2.44a.2.2,0,0,0,.18.16l2.91.3a.2.2,0,0,0,.2-.12l1-2.27a10.59,10.59,0,0,0,3.29-1l2.07,1.32a.2.2,0,0,0,.24,0l2.26-1.9a.2.2,0,0,0,.06-.23L105.81,40a10.92,10.92,0,0,0,1.63-3.12l2.37-.57a.2.2,0,0,0,.16-.18l.29-3a.22.22,0,0,0-.11-.21l-2.21-1.05a11.65,11.65,0,0,0-1-3.39l1.28-2.13a.21.21,0,0,0,0-.24l-1.85-2.33a.19.19,0,0,0-.22-.06l-2.29.86a10.53,10.53,0,0,0-3-1.67l-.55-2.44a.2.2,0,0,0-.18-.16L97.18,20a.2.2,0,0,0-.2.11l-1,2.28a10.09,10.09,0,0,0-3.29,1l-2.08-1.32a.2.2,0,0,0-.23,0L88.1,24a.2.2,0,0,0-.06.23l.84,2.36a10.86,10.86,0,0,0-1.63,3.11l-2.37.58a.2.2,0,0,0-.16.18l-.29,3a.22.22,0,0,0,.11.21l2.21,1a11.23,11.23,0,0,0,1,3.39l-1.28,2.13a.21.21,0,0,0,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M97.34,36.5a3,3,0,0,1-1.83-.63,3.19,3.19,0,0,1,1.38-5.68,3,3,0,0,1,2.29.59,3.15,3.15,0,0,1,1.21,2.08,3.23,3.23,0,0,1-.57,2.36,3,3,0,0,1-2,1.24A3.42,3.42,0,0,1,97.34,36.5Zm0-5.35a1.63,1.63,0,0,0-.31,0,2.18,2.18,0,0,0-1,3.88,2,2,0,0,0,1.56.41A2.14,2.14,0,0,0,99,34.62,2.25,2.25,0,0,0,99.43,33a2.17,2.17,0,0,0-.83-1.43A2.06,2.06,0,0,0,97.35,31.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M97.4,40.7a6.23,6.23,0,0,1-.74,0h0a6.91,6.91,0,0,1-1.5-.32.16.16,0,0,1-.11-.16v0a.16.16,0,0,1,.21-.11,6.41,6.41,0,0,0,1.43.31,6.72,6.72,0,0,0,5.06-1.56,7.14,7.14,0,0,0,2.5-4.78q0-.36,0-.72a6.89,6.89,0,0,0-13.75-.71q0,.36,0,.72a7.24,7.24,0,0,0,.65,3,.15.15,0,0,1,0,.07.16.16,0,0,1-.09.15.17.17,0,0,1-.22-.08,7.56,7.56,0,0,1-.68-3.15,6.28,6.28,0,0,1,0-.75,7.29,7.29,0,0,1,7.91-6.64,7.36,7.36,0,0,1,6.49,7.38c0,.25,0,.5,0,.76A7.47,7.47,0,0,1,102,39,7,7,0,0,1,97.4,40.7Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatiserlesconsentements);
export default __webpack_public_path__ + "static/media/Automatiser les consentements.1ca3f5c26e6dff9584dc8148654773ae.svg";
export { ForwardRef as ReactComponent };